import React from "react";
import "./ConfirmModal.css";

const ConfirmModal = ({ open, title, message, onCancel, onConfirm }) => {
  if (!open) return null;

  return (
    <>
      {/* BACKDROP */}
      <div className="confirm-backdrop" onClick={onCancel}></div>

      {/* BOTTOM SHEET */}
      <div className="confirm-sheet slide-up">
        <h3 className="confirm-title">{title}</h3>
        <p className="confirm-message">{message}</p>

        <div className="confirm-actions">
          <button className="confirm-cancel" onClick={onCancel}>
            Cancel
          </button>

          <button className="confirm-delete" onClick={onConfirm}>
            Yes, Continue
          </button>
        </div>
      </div>
    </>
  );
};

export default ConfirmModal;
